var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[((this.$store.state.User.user_id))?_c('div',[_c('Main',{staticClass:"ma-4"}),_c('Report',{directives:[{name:"show",rawName:"v-show",value:(_vm.reportAuth),expression:"reportAuth"}],staticClass:"ma-4"})],1):_c('div',{staticClass:"home-container"},[_c('BookNow')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }